import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createRefund } from "api/refund.api";
import {
  invalidateDashboardSources,
  invalidateRefundSide,
} from "lib/cacheInvalidation";

export const useCreateRefund = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createRefund,
    onSuccess: () => {
      invalidateRefundSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
